import { Building2, Home, Clock, Archive, Users, CheckCircle2, Settings, Calculator, BarChart, Building, KeyRound } from 'lucide-react';

export const navigationItems = [
  { icon: Building2, label: 'Biens en Vente', href: '/en-vente' },
  { icon: Building, label: 'Promotions', href: '/promotions' },
  { icon: Calculator, label: 'Estimations', href: '/estimations' },
  { icon: Home, label: 'Locations', href: '/en-location' },
  { icon: Clock, label: 'Locations Courte Durée', href: '/location-courte-duree' },
  { icon: KeyRound, label: 'Conciergerie', href: '/conciergerie' },
  { icon: CheckCircle2, label: 'Biens Vendus', href: '/vendus' },
  { icon: CheckCircle2, label: 'Biens Loués', href: '/loues' },
  { icon: Archive, label: 'Biens archivés', href: '/archives' },
  { icon: Users, label: 'Clients Actifs', href: '/clients-actifs' },
  { icon: Archive, label: 'Clients archivés', href: '/clients-archives' },
  { icon: BarChart, label: 'Statistiques', href: '/statistiques' },
  { icon: Settings, label: 'Paramètres', href: '/settings' },
];